import React from 'react';
import { Label } from '@/components/ui/label';
import { Input } from '@/components/ui/input';
import { ToggleRow, SMALL_TRIGGER } from '@/components/report-builder/config-panel/sections';

/**
 * Format-panel for the Sankey plugin. Mounted by ConfigPanel when vizType === 'sankey'.
 *
 * Receives the standard config-panel props { cfg, set, currentVisual, allFields, ... }.
 * Only `cfg` and `set` are needed for this minimal plugin.
 */
export function SankeyConfigPanel({ cfg, set }) {
  return (
    <React.Fragment>
      <ToggleRow label="Show Node Labels" checked={cfg.showLabels !== false} onChange={v => set('showLabels', v)} />
      <div>
        <Label className="text-[8px] text-muted-foreground">Node Padding</Label>
        <Input
          type="number" min={0} max={80} value={cfg.nodePadding ?? 20}
          onChange={e => set('nodePadding', Number(e.target.value))}
          className={SMALL_TRIGGER}
          data-testid="sankey-node-padding"
        />
      </div>
      <div>
        <Label className="text-[8px] text-muted-foreground">Node Width</Label>
        <Input
          type="number" min={4} max={40} value={cfg.nodeWidth ?? 12}
          onChange={e => set('nodeWidth', Number(e.target.value))}
          className={SMALL_TRIGGER}
        />
      </div>
      <div>
        <Label className="text-[8px] text-muted-foreground">Link Opacity</Label>
        <Input
          type="number" step={0.05} min={0} max={1} value={cfg.linkOpacity ?? 0.4}
          onChange={e => set('linkOpacity', Number(e.target.value))}
          className={SMALL_TRIGGER}
        />
      </div>
      <div>
        <Label className="text-[8px] text-muted-foreground">Link Color (hex)</Label>
        <Input
          value={cfg.linkColor ?? ''} placeholder="#3b82f6"
          onChange={e => set('linkColor', e.target.value)}
          className={SMALL_TRIGGER}
        />
      </div>
    </React.Fragment>
  );
}
